module.exports = __webpack_public_path__ + "img/bg1@2x (1).75188460.png";